import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { applicationsReducer } from "./slices/applications";
import { candidatesReducer } from "./slices/candidates";
import { customersReducer } from "./slices/customers";
import { projectsReducer } from "./slices/projects";
import { guidesReducer } from "./slices/guides";
import { vacancyApplicationsReducer } from "./slices/vacancyApplications";
import { vacancyReducer } from "./slices/vacancy";
import { analyticsReducer } from "./slices/analytics";
import { departmentsReducer } from "./slices/departments";
import { userReducer } from "./slices/user";
import { notificationsReducer } from "./slices/notifications";

export const store = configureStore({
  reducer: {
    applications: applicationsReducer,
    candidates: candidatesReducer,
    customers: customersReducer,
    projects: projectsReducer,
    guides: guidesReducer,
    vacancyApplications: vacancyApplicationsReducer,
    vacancy: vacancyReducer,
    analytics: analyticsReducer,
    departments: departmentsReducer,
    user: userReducer,
    notifications: notificationsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function isError(action: { type: string }) {
  return action.type.endsWith("rejected");
}
